import { EditionAPI } from '../../../api/datamanager/EditionAPI';

export class EditionsCommand {
    constructor() {
        this.editionApi = new EditionAPI();
    }

    get(type, providerId, successCallback, errorCallback) {
        const apiResult = this.editionApi.get(type, undefined === providerId || null === providerId ? '' : providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getImportable(type, providerId, successCallback, errorCallback) {
        const apiResult = this.editionApi.getImportable(type, undefined === providerId || null === providerId ? '' : providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(type, form, successCallback, errorCallback) {
        let apiResult = null;
        if ("create" === form.operation) {
            apiResult = this.editionApi.save(type, { id: 0, name: form.name });
        }
        else {
            apiResult = this.editionApi.update(type, form.obj.id, form.obj);
        }

        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    copy(type, form, successCallback, errorCallback) {
        const apiResult = this.editionApi.copy(type, form.obj);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateState(type, form, successCallback, errorCallback) {
        let apiResult = null;
        const dataToSend = form.obj;

        switch(form.operation) {
            case "publish":
                apiResult = this.editionApi.publish(type, form.obj.id, dataToSend);
                break;

            case "archive":
                apiResult = this.editionApi.archive(type, form.obj.id, dataToSend);
                break;

            default:
                if (undefined !== errorCallback) {
                    errorCallback("Operação Inválida!");
                }
                return;
        }

        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(type, id, successCallback, errorCallback) {
        const apiResult = this.editionApi.delete(type, id);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/EditionsCommand.js